export default function renderDrawRules(lottery_rule) {
    let rulesString = '';

    if (lottery_rule) {
        const { numbers_per_line, ranges } = lottery_rule;
        numbers_per_line.forEach((number, key) => {
            if (key > 0) {
                rulesString += '+';
            }
            rulesString += number + '(' + ranges[key][1] + ')';
        });
    }

    return rulesString;
}
